import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useCommunityInboxStore } from "@/react/hooks/chatsV2/store";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { newChatRoomPath } from "@circle-react/helpers/urlHelpers";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

export const ConversationLengthWarning = ({
  communityBotProfile,
  conversationStatus,
  isDms,
}: {
  communityBotProfile: any;
  conversationStatus: "getting_too_long" | "too_long" | "exceeded" | "normal";
  isDms: boolean;
}) => {
  const history = useHistory();
  const { setCurrentBotProfile } = useCommunityInboxStore();

  const handleNewChat = () => {
    setCurrentBotProfile(communityBotProfile);
    history.push(newChatRoomPath());
  };

  const notificationText =
    conversationStatus === "getting_too_long"
      ? t("community_inbox.conversation_getting_too_long")
      : t("community_inbox.conversation_too_long");

  if (isDms) {
    return (
      <div
        className={classNames(
          "mb-4 flex items-center gap-2 rounded-2xl p-3 pl-4",
          {
            "bg-amber-50 dark:bg-[#F59E0B26]":
              conversationStatus === "getting_too_long" ||
              conversationStatus === "too_long",
            "bg-red-50 dark:bg-[#EF444426]": conversationStatus === "exceeded",
          },
        )}
      >
        <div className="shrink-0 grow basis-0">
          <Typography.LabelSm
            weight="medium"
            color="text-[#545861] dark:text-[#E4E7EB]"
          >
            {notificationText}
          </Typography.LabelSm>
        </div>
        <div>
          <Button variant="circle" onClick={handleNewChat}>
            {t("community_inbox.start_new_conversation")}
          </Button>
        </div>
      </div>
    );
  }

  if (conversationStatus === "too_long" || conversationStatus === "exceeded") {
    return (
      <div
        className={classNames(
          "mb-4 flex items-center gap-2 rounded-2xl p-3 pl-4",
          {
            "bg-amber-50 dark:bg-[#F59E0B26]":
              conversationStatus === "too_long",
            "bg-red-50 dark:bg-[#EF444426]": conversationStatus === "exceeded",
          },
        )}
      >
        <div className="shrink-0 grow basis-0">
          <Typography.LabelSm
            weight="medium"
            color="text-[#545861] dark:text-[#E4E7EB]"
          >
            {t("community_inbox.conversation_too_long_admin")}
          </Typography.LabelSm>
        </div>
      </div>
    );
  }

  return null;
};
